import { Toast } from 'antd-mobile';
import { biubiuBuildingInfo, biubiuBuildingRank, biubiuBuildingDetail, biubiuBuildingRush, biubiuBuildingFloat, biubiuBuildingAvailableCount } from '@/services/activity';

export default {
  namespace: 'activityBiuBiuBuilding',
  state: {
    endTime: 0,
    musicUrl: '',
    title: '',
    titleUrl: '',
    rules: '',
    childPageUrl: '',
    childBgColor: '',
    gifts: [],
    ranks: [],
    selfInfo: {},
    receiveRewards: [],
    sendRewards: [],
    lastId: '',
    status: 1,
    days: {},
    nowDay: '',
    pageNum: 1,
    pageSize: 20,
    detailsMap: [],
    leve1AvailableCount: 0,
    leve2AvailableCount: 0,
    firstLevelCarCount: 0,
    firstLevelCarCostCoins: 0,
    secondLevelCarCount: 0,
    secondLevelCarCostCoins: 0,
    isMore: false,
    obtainedRewards: [],
    rushTimes: [],
    collisionAnimationMap: {},
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        endTime: payload.endTime || 0,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        status: payload.activityStatus || 0,
        days: payload.days || {},
        nowDay: payload.now || '',
        leve1AvailableCount: payload.leve1AvailableCount <= 0 ? 0 : payload.leve1AvailableCount, // 数据问题兼容，一开始再redis就是负的
        leve2AvailableCount: payload.leve2AvailableCount <= 0 ? 0 : payload.leve2AvailableCount, // 数据问题兼容，一开始再redis就是负的
        firstLevelCarCount: payload.firstLevelCarCount || 0,
        secondLevelCarCount: payload.secondLevelCarCount || 0,
        firstLevelCarCostCoins: payload.firstLevelCarCostCoins || 0,
        secondLevelCarCostCoins: payload.secondLevelCarCostCoins || 0,
        rushTimes: payload.rushTimes || [],
        collisionAnimationMap: payload.collisionAnimationMap || {},
        rulesAndRewardsUrl: payload.rulesAndRewardsUrl || '',
      };
    },
    updateList(state, { payload }) {
      let list = payload.force ? [] : [...state.ranks];
      let selfInfo = {};
      let lastId = '';
      if (payload.ranks && payload.ranks.length) {
        list = [...list, ...payload.ranks];
        lastId = payload.ranks[payload.ranks.length - 1].userId;
      }
      if (payload.selfInfo && payload.selfInfo.userId) {
        selfInfo = payload.selfInfo;
      }
      return {
        ...state,
        selfInfo: selfInfo,
        ranks: list,
        lastId: lastId,
      };
    },
    updateDetailList(state, { payload }) {
      let newList = payload.force ? [] : [...state.detailsMap];
      let isMore = false;
      if (payload.detailInfoList && payload.detailInfoList.length) {
        newList = [...newList, ...payload.detailInfoList];
        isMore = !!payload.detailInfoList[payload.detailInfoList.length - 1];
      }
      return {
        ...state,
        detailsMap: newList,
        pageNum: payload.nextPageNum || 1,
        isMore: isMore,
      };
    },
    updateRushTime(state, { payload }) {
      return {
        ...state,
        leve1AvailableCount: payload.leve1AvailableCount <= 0 ? 0 : payload.leve1AvailableCount,
        leve2AvailableCount: payload.leve2AvailableCount <= 0 ? 0 : payload.leve2AvailableCount,
        obtainedRewards: payload.obtainedRewards || [],
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(biubiuBuildingInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return true;
    },
    *getList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.activityBiuBiuBuilding);
      const { error, data } = yield call(biubiuBuildingRank, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *clearList({ payload }, { call, put }) {
      yield put({
        type: 'updateList',
        payload: { force: true },
      });
    },
    *getDetailList({ payload }, { call, put, select }) {
      const { pageNum, pageSize } = yield select(state => state.activityBiuBiuBuilding);
      const { error, data } = yield call(biubiuBuildingDetail, {
        ...payload,
        pageNum: payload.force ? 1 : pageNum,
        pageSize: pageSize,
        force: undefined,
      });
      if (error || !data) {
        yield put({
          type: 'updateDetailList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateDetailList',
        payload: { ...data, pageNum: payload.pageNum, force: payload.force },
      });
      return true;
    },
    *clearDetailList({ payload }, { call, put }) {
      yield put({
        type: 'updateDetailList',
        payload: { force: true },
      });
    },
    *buildRush({ payload }, { call, put }) {
      const { error, data } = yield call(biubiuBuildingRush, payload);
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        yield put({
          type: 'updateRushTime',
          payload: { ...data },
        });
        return {
          success: true,
          data: { ...data },
        };
      } else {
        return false;
      }
    },
    *buildAvailable({ payload }, { call, put }) {
      const { error, data } = yield call(biubiuBuildingAvailableCount, payload);
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        yield put({
          type: 'updateRushTime',
          payload: { ...data },
        });
        return {
          success: true,
          data: { ...data },
        };
      } else {
        return false;
      }
    },
    *getFloatList({ payload }, { call }) {
      const { error, data } = yield call(biubiuBuildingFloat, payload);
      const buildingInfoList = data && data.buildingInfoList ? data.buildingInfoList : [];
      const rewardInfoList = data && data.rewardInfoList ? data.rewardInfoList : [];
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        return {
          success: true,
          data: [...buildingInfoList, ...rewardInfoList],
        };
      } else {
        return false;
      }
    },
  },
};
